<template>
  <div class="whitespace-nowrap text-center">
    <div class="buttons">
      <button class="btn-prev" @click="fat.amount = fat.amount-1" :disabled="fat.amount === 1">
        <AtomIcon name="circle-minus" />
      </button>
      <div v-auto-animate>
        <button class="button" v-for="amount in amounts" :key="amount" :class="{ 'active': fat.amount === amount }" @click="fat.amount = amount">
          <div class="font-bold text-lg md:text-xl">
            {{ amount }}
          </div>
        </button>
      </div>
      <button class="btn-next" @click="fat.amount = fat.amount+1" :disabled="fat.amount >= 8">
        <AtomIcon name="circle-plus" />
      </button>
    </div>
    <div class="text-sm text-black">{{ $t('shared.amount') }}</div>
  </div>
</template>

<script setup>
const app = useAppStore()
const fat = useFatStore()
const amountsLimit = ref(1)

// Change number of available times based on screen size
const updateAmountsLimit = () => {
  const width = window.innerWidth
  amountsLimit.value = width < 768 ? 1 : 3
  // amountsLimit.value = width < 1024 ? 1 : 3
  // amountsLimit.value = width < 1280 ? 1 : 3
}

// Update times limit on mounted, with resize changes
onMounted(() => {
  updateAmountsLimit()
  window.addEventListener('resize', updateAmountsLimit)
})

// Remove resize listener
onBeforeUnmount(() => {
  window.removeEventListener('resize', updateAmountsLimit)
})

// Get available amounts based on amounts limit
const amounts = computed(() => {
  const maxAmount = 8
  const limit = amountsLimit?.value

  // Force center value to 3 if amount is set to 2 or 3
  const centerValue = [2, 3].includes(fat.amount) && amountsLimit.value > 1
    ? Math.ceil(amountsLimit.value / 2) + 1 
    : fat.amount

  // Generate all available amounts from 1 to 8
  const allAmounts = Array.from({ length: maxAmount }, (_, i) => i + 1)

  // Find index of the center value
  const centerIndex = allAmounts.indexOf(centerValue)

  // Calculate how many values before and after
  const beforeCount = Math.floor((limit - 1) / 2)
  const afterCount = limit - 1 - beforeCount

  let start = Math.max(0, centerIndex - beforeCount)
  let end = Math.min(allAmounts.length, centerIndex + afterCount + 1)
  let sliced = allAmounts.slice(start, end)

  // If sliced is too short (e.g., near beginning or end), pad it
  while (sliced?.length < limit) {
    if (start > 0) {
      sliced.unshift(allAmounts[start - 1])
      start--
    } else if (end < allAmounts.length) {
      sliced.push(allAmounts[end])
      end++
    } else {
      break
    }
  }

  return sliced
})
</script>

<style lang="scss" scoped>
.buttons {
  @apply flex items-center justify-center px-8 relative;

  button {
    @apply duration-300 w-7;

    &.active {
      @apply border-coral text-coral;

      &:deep(svg) {
        @apply text-black;
      }
    }
  }

  .btn-prev, 
  .btn-next {
    @apply absolute z-10 top-0 h-full w-8 flex items-center justify-center;

    &:disabled {
      @apply opacity-40;
    }
  } 

  .btn-prev {
    @apply left-0;
  }

  .btn-next {
    @apply right-0;
  }
}
</style>